import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config } from '../../_helpers/config.class';
import { CreateProfile } from '../account.model';

@Injectable()
export class LoginService {
  constructor(private http: HttpClient) { }
  login(user) {
    return this.http.post(`${Config.getApiUrl()}/Account/Token`, {username: user.username , password: user.password});
  }

  sendForgetPasswordEmail(email) {
    return this.http.post(`${Config.getApiUrl()}/Account/SendForgetPasswordEmail`, {email: email});
  }
  
  resetPassword(reset) {
    return this.http.post(`${Config.getApiUrl()}/Account/ResetPassword`, {email: reset.email , verificationCode: reset.verificationCode, Password: reset.Password});
  }

  verifyEmail(verify) {
    return this.http.post(`${Config.getApiUrl()}/Account/VerifyEmail`, {email: verify.Email});
  }

  public createProfile(obj: CreateProfile) {
    const formData = new FormData();
    if (obj.DPFile != null) {
      if ((obj.DPFile.Name = "DP")) {
        formData.append("DP", obj.DPFile);
      }
    }
  
    formData.append("Obj", JSON.stringify(obj));
      return this.http.post(
        `${Config.getControllerUrl("Account", "CreateProfile")}`,
        formData
      );
  }

  isValidUsername(username,id) {
    return this.http.post(`${Config.getApiUrl()}/Account/IsValidUsername`, {code: username,  StringId: id});
  }
}
//'username=' + user.username + '&password=' + user.password + '&grant_type=password'